(() => {
  'use strict';
  const normalize = value => (Array.isArray(value) ? value : value == null ? [] : [value]).filter(v => v !== '' && v != null).map(String);
  const signature = value => normalize(value).map(v => v.trim().toLowerCase()).sort().join('|');
  const different = values => new Set(values.map(signature)).size > 1;
  const toggle = (items, handle) => items.includes(handle) ? items.filter(h => h !== handle) : items.length < 3 ? [...items, handle] : items;
  const parseHandles = value => [...new Set(String(value || '').split(','))].filter(h => /^[a-z0-9-]+$/.test(h)).slice(0, 3);
  if (typeof module !== 'undefined') module.exports = { normalize, signature, different, toggle, parseHandles };
  if (typeof document === 'undefined') return;
  const root = document.getElementById('mg-compare-root');
  if (!root) return;
  const en = root.dataset.locale === 'en';
  const tr = (es, english) => en ? english : es;
  const key = 'mg-compare-prototype-v1';
  const tray = root.querySelector('aside'), content = document.getElementById('mg-compare-page-content'), status = root.querySelector('[role=status]');
  const isPage = Boolean(content);
  let handles = [], products = new Map(), busy = false, onlyDiff = false;
  try { handles = [...new Set(JSON.parse(localStorage.getItem(key) || '[]'))].filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)).slice(0, 3); } catch (_) {}
  const params = new URLSearchParams(location.search);
  if (isPage && params.has('compare')) handles = parseHandles(params.get('compare'));
  const el = (tag, text, className) => { const n = document.createElement(tag); if (text != null) n.textContent = text; if (className) n.className = className; return n; };
  const button = (text, action, className) => { const n = el('button', text, className); n.type = 'button'; n.addEventListener('click', action); return n; };
  const announce = text => { status.textContent = text; };
  const money = p => (p.priceVaries ? tr('Desde ', 'From ') : '') + new Intl.NumberFormat(en ? 'en-MX' : 'es-MX', {style: 'currency', currency: 'MXN'}).format(p.price / 100) + ' MXN';
  const save = () => {
    try { localStorage.setItem(key, JSON.stringify(handles)); } catch (_) {}
    if (isPage) { const url = new URL(location.href); url.searchParams.set('compare', handles.join(',')); history.replaceState(null, '', url); }
  };
  function collectionUrl(compare = false) {
    const url = new URL(root.dataset.root.replace(/\/$/, '') + '/collections/all', location.origin);
    url.searchParams.set('preview_theme_id', root.dataset.theme);
    if (compare) { url.searchParams.set('view', 'mg-compare'); url.searchParams.set('compare', handles.join(',')); }
    return url;
  }
  function productUrl(handle, view) {
    const base = root.dataset.root.replace(/\/$/, '');
    const url = new URL(`${base}/products/${encodeURIComponent(handle)}`, location.origin);
    // Keep this prototype inside its unpublished theme, including asynchronous views.
    url.searchParams.set('preview_theme_id', root.dataset.theme);
    if (view) url.searchParams.set('view', view);
    return url;
  }
  async function load(handle) {
    const response = await fetch(productUrl(handle, 'mg-compare'), {credentials: 'same-origin'});
    if (!response.ok) throw new Error('product unavailable');
    const p = await response.json();
    if (p.handle !== handle || !p.specs || typeof p.title !== 'string') throw new Error('invalid product');
    products.set(handle, p); return p;
  }
  function remove(handle) {
    handles = handles.filter(h => h !== handle); save(); renderTray();
    if (isPage) { renderTable(); content.querySelector('h1')?.focus(); }
    announce(tr('Producto retirado del comparador.', 'Product removed from comparison.'));
  }
  function renderTray() {
    document.querySelectorAll('[data-mg-compare]').forEach(b => {
      const active = handles.includes(b.dataset.mgCompare);
      b.setAttribute('aria-pressed', String(active));
      b.textContent = active ? tr('✓ En comparación', '✓ Selected') : tr('＋ Comparar', '＋ Compare');
      b.disabled = busy;
    });
    tray.replaceChildren(); tray.hidden = isPage || !handles.length;
    if (isPage || !handles.length) return;
    tray.append(el('p', tr('COMPARAR PRODUCTOS', 'COMPARE PRODUCTS'), 'mg-compare-eyebrow'));
    const slots = el('div', null, 'mg-compare-slots');
    for (let i = 0; i < 3; i++) {
      const h = handles[i], p = products.get(h), slot = el('div', null, 'mg-compare-slot');
      if (h) {
        if (p?.image) { const img = el('img'); img.src = p.image; img.alt = ''; slot.append(img); }
        slot.append(el('span', p ? p.title : tr('Cargando…', 'Loading…')));
        const b = button('×', () => remove(h)); b.setAttribute('aria-label', tr('Quitar ', 'Remove ') + (p?.title || h)); slot.append(b);
      } else slot.append(el('span', tr('Añade otro producto', 'Add another product')));
      slots.append(slot);
    }
    tray.append(slots);
    const open = button(tr(`Comparar (${handles.length})`, `Compare (${handles.length})`), openTable, 'mg-compare-primary');
    open.disabled = handles.length < 2 || busy || handles.some(h => !products.has(h)); tray.append(open);
    tray.append(button(tr('Vaciar', 'Clear'), () => { handles = []; save(); renderTray(); }, 'mg-compare-clear'));
  }
  function rows(items) {
    const specs = [
      ['type', tr('Tipo de producto', 'Product type')], ['availability', tr('Disponibilidad', 'Availability')],
      ['options', tr('Opciones del producto', 'Product options')], ['cert', tr('Certificaciones', 'Certifications')],
      ['shell', tr('Material de calota', 'Shell material')], ['liner', tr('Interior', 'Liner')],
      ['material', tr('Materiales', 'Materials')], ['protection', tr('Protecciones', 'Protection')],
      ['weight', tr('Peso', 'Weight')], ['features', tr('Características de la ficha', 'Product features')], ['box', tr('Contenido de caja', "What's included")]
    ];
    return specs.map(([id, title]) => ({id, title, values: items.map(p => {
      if (id === 'type') return p.type;
      if (id === 'availability') return p.available ? tr('Hay variantes disponibles', 'Variants available') : tr('Agotado', 'Sold out');
      if (id === 'options') return p.options.filter(o => !['Title', 'Título'].includes(o.name)).map(o => `${o.name}: ${o.values.join(', ')}`);
      if (id === 'weight') return p.specs.weight ? `${p.specs.weight} g` : null;
      return p.specs[id];
    })})).filter(r => ['type', 'availability', 'options', 'features'].includes(r.id) || r.values.some(v => normalize(v).length));
  }
  function renderTable() {
    const items = handles.map(h => products.get(h)).filter(Boolean);
    content.replaceChildren();
    const top = el('header', null, 'mg-compare-heading');
    const title = el('h1', tr('COMPARA TU EQUIPO', 'COMPARE YOUR GEAR')); title.id = 'mg-compare-title';
    title.tabIndex = -1;
    const back = el('a', tr('← Seguir explorando', '← Continue shopping'), 'mg-compare-link'); back.href = collectionUrl();
    top.append(title, back); content.append(top);
    content.append(el('p', tr('Hasta tres productos. Datos de sus fichas; revisa talla y disponibilidad al elegir.', 'Up to three products. Data from their listings; check size and availability before choosing.'), 'mg-compare-note'));
    const label = el('label', null, 'mg-compare-differences'), check = el('input'); check.type = 'checkbox'; check.checked = onlyDiff;
    check.addEventListener('change', () => { onlyDiff = check.checked; renderTable(); content.querySelector('input').focus(); }); label.append(check, document.createTextNode(tr('Mostrar sólo diferencias', 'Show differences only'))); content.append(label);
    if (new Set(items.map(p => p.type).filter(Boolean)).size > 1) content.append(el('p', tr('Estos productos son de tipos distintos: algunas características no son equivalentes.', 'These products are different types: some features may not be comparable.'), 'mg-compare-note'));
    if (items.length < 2) { content.append(el('p', tr('Añade al menos dos productos para comparar.', 'Add at least two products to compare.'))); return; }
    const wrap = el('div', null, 'mg-compare-scroll'); wrap.tabIndex = 0; wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-label', tr('Tabla de comparación, desplazable horizontalmente', 'Comparison table, scroll horizontally'));
    const table = el('table'), caption = el('caption', tr('Comparación de productos', 'Product comparison'), 'mg-compare-sr'); table.append(caption);
    const head = el('thead'), hr = el('tr'); hr.append(el('th', tr('CARACTERÍSTICA', 'FEATURE')));
    items.forEach(p => {
      const th = el('th'); th.scope = 'col';
      if (p.image) { const img = el('img'); img.src = p.image; img.alt = p.title; th.append(img); }
      th.append(el('p', p.vendor, 'mg-compare-eyebrow'), el('h3', p.title), el('p', money(p), 'mg-compare-price'));
      const link = el('a', tr('Ver producto ↗', 'View product ↗'), 'mg-compare-link'); link.href = productUrl(p.handle); th.append(link, button(tr('Quitar', 'Remove'), () => remove(p.handle), 'mg-compare-remove')); hr.append(th);
    }); head.append(hr); table.append(head);
    const body = el('tbody'); let visible = 0;
    rows(items).forEach(row => {
      if (onlyDiff && !different(row.values)) return;
      visible++; const trNode = el('tr'); const th = el('th', row.title); th.scope = 'row'; trNode.append(th);
      row.values.forEach(value => {
        const td = el('td'), list = normalize(value);
        if (!list.length) td.append(el('span', tr('No especificado', 'Not specified'), 'mg-compare-empty'));
        else if (list.length === 1) td.textContent = list[0];
        else { const ul = el('ul'); list.forEach(v => ul.append(el('li', v))); td.append(ul); }
        trNode.append(td);
      }); body.append(trNode);
    });
    table.append(body); wrap.append(table); content.append(wrap);
    if (!visible) content.append(el('p', tr('No hay diferencias en los campos disponibles.', 'No differences in the available fields.')));
  }
  function openTable() { location.assign(collectionUrl(true).href); }
  document.addEventListener('click', async event => {
    const b = event.target.closest('[data-mg-compare]'); if (!b || busy) return;
    const h = b.dataset.mgCompare;
    if (handles.includes(h)) return remove(h);
    if (handles.length === 3) return announce(tr('Puedes comparar hasta tres productos. Quita uno para añadir otro.', 'Compare up to three products. Remove one to add another.'));
    busy = true; renderTray(); announce(tr('Cargando producto…', 'Loading product…'));
    try { await load(h); handles = toggle(handles, h); save(); announce(tr('Producto añadido al comparador.', 'Product added to comparison.')); }
    catch (_) { announce(tr('No pudimos cargar este producto. Inténtalo de nuevo.', 'Could not load this product. Please try again.')); }
    finally { busy = false; renderTray(); }
  });
  // AJAX filtering may replace the grid; reflect the persistent selection in new cards.
  new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-mg-compare]') || n.querySelector?.('[data-mg-compare]'))))) renderTray(); }).observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
  renderTray();
  async function restoreSelection() {
    busy = true; renderTray();
    if (isPage) content.setAttribute('aria-busy', 'true');
    const failed = [];
    await Promise.all(handles.map(async h => { try { await load(h); } catch (_) { failed.push(h); } }));
    busy = false; save(); renderTray();
    if (isPage) {
      renderTable(); content.setAttribute('aria-busy', 'false');
      if (failed.length) {
        const error = el('div', null, 'mg-compare-load-error'); error.setAttribute('role', 'alert');
        error.append(el('p', tr('No se pudieron cargar algunos productos. La selección se conserva.', 'Some products could not be loaded. Your selection has been kept.')),
          button(tr('Reintentar', 'Retry'), restoreSelection));
        content.append(error);
      }
    } else if (failed.length) announce(tr('No se pudieron cargar algunos productos. Intenta seleccionarlos de nuevo.', 'Some products could not be loaded. Try selecting them again.'));
  }
  restoreSelection();
})();
